import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Printer } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, pad } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Button } from "@/components/ui/button";

export const REKAP_COLS = [
  ["total", "Jiwa"], ["laki", "L"], ["perempuan", "P"], ["kepala_keluarga", "KK"], ["oap", "OAP"], ["non_oap", "Non-OAP"],
  ["bayi", "Bayi"], ["balita", "Balita"], ["anak", "Anak"], ["produktif", "Produktif"], ["lansia", "Lansia"],
  ["tidak_produktif", "Tdk Produktif"], ["miskin", "Miskin"], ["tidak_mampu", "Tdk Mampu"], ["disabilitas", "Disabilitas"],
];

export const RekapTable = ({ data, onRow }) => (
  <table className="w-full text-sm border-collapse" data-testid="rekap-table">
    <thead>
      <tr className="bg-[#0b4f4a] text-white text-[11px] uppercase">
        <th className="px-3 py-2.5 text-left">RT</th>
        {REKAP_COLS.map(([, l]) => <th key={l} className="px-2 py-2.5 text-right whitespace-nowrap">{l}</th>)}
      </tr>
    </thead>
    <tbody>
      {data.per_rt.map((r) => (
        <tr key={r.rt} onClick={() => onRow?.(r.rt)} className={`border-b ${onRow ? "cursor-pointer hover:bg-amber-50" : ""}`} data-testid={`rekap-row-${r.rt}`}>
          <td className="px-3 py-2 font-semibold">RT {pad(r.rt)}</td>
          {REKAP_COLS.map(([k]) => <td key={k} className="px-2 py-2 text-right tabular-nums">{r[k]}</td>)}
        </tr>
      ))}
      <tr className="bg-amber-100 font-bold" data-testid="rekap-total-row">
        <td className="px-3 py-2.5">JUMLAH</td>
        {REKAP_COLS.map(([k]) => <td key={k} className="px-2 py-2.5 text-right tabular-nums">{data.summary[k]}</td>)}
      </tr>
    </tbody>
  </table>
);

export default function RekapRT() {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/stats").then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  return (
    <div data-testid="rekap-page">
      <PageHeader kicker="RT 01 – RT 16" title="Rekapitulasi per RT">
        <Button asChild className="bg-[#0b4f4a] hover:bg-[#072f2c]" data-testid="rekap-print-button">
          <a href="/cetak" target="_blank" rel="noreferrer"><Printer className="h-4 w-4 mr-2" /> Cetak Rekap</a>
        </Button>
      </PageHeader>
      <p className="text-sm text-slate-500 mb-4">Hanya menghitung warga berstatus aktif. Klik baris untuk melihat daftar warga RT tersebut.</p>
      <div className="bg-white border rounded-xl overflow-x-auto">
        {data ? <RekapTable data={data} onRow={(rt) => nav(`/warga?rt=${rt}`)} /> : <div className="p-10 text-center text-slate-500">Memuat…</div>}
      </div>
    </div>
  );
}
